export default __webpack_public_path__ + "static/media/logoaccess.504ea376.png";